<template>
  <div></div>
</template>
<script>
import _ from 'lodash'
export default {
  name: 'Meta',
  props: {
    contentInfo: {
      type: Object
    },
    contentType: {
      type: String
    }
  },
  metaInfo () {
    return {
      meta: [
        { property: 'og:type', content: this.getType, vmid: 'og:type' },
        { property: 'og:title', content: this.getTitle, vmid: 'og:title' },
        { property: 'og:image', content: this.getImage, vmid: 'og:image' },
        { property: 'og:image:secure_url', content: this.getImageSecureUrl, vmid: 'og:image:secure_url' },
        { property: 'og:description', content: this.getDescription, vmid: 'og:description' },
        { property: 'og:url', content: `www.wavve.com${this.$route.fullPath}`, vmid: 'og:url' }
      ]
    }
  },
  computed: {
    getType () {
      let type = ''
      switch (this.contentType) {
        case 'vod':
        case 'live':
          type = 'video.episode'
          break
        case 'movie':
          type = 'video.movie'
          break
        default:
          type = ''
      }
      return type
    },
    getDescription () {
      let description = ''
      switch (this.contentType) {
        case 'vod':
          description = _.get(this.contentInfo, 'episodenumber', '') + '회 ' + _.get(this.contentInfo, 'episodetitle', '')
          break
        case 'live':
          description = _.get(this.contentInfo, 'title', '')
          break
        case 'movie':
          description = _.get(this.contentInfo, 'synopsis', '')
          break
        default:
          description = ''
      }
      return description
    },
    getTitle () {
      let title = ''
      switch (this.contentType) {
        case 'vod':
          title = `[wavve]${_.get(this.contentInfo, 'programtitle', '')}`
          break
        case 'live':
          title = `[wavve]${_.get(this.contentInfo, 'channelname', '')}`
          break
        case 'movie':
          title = `[wavve]${_.get(this.contentInfo, 'title', '')}`
          break
        default:
          title = ''
      }
      return title
    },
    getImageSecureUrl () {
      return 'https://' + _.get(this.contentInfo, 'image', '').replace('http://', '').replace('https://', '')
    },
    getImage () {
      return 'http://' + _.get(this.contentInfo, 'image', '').replace('http://', '').replace('https://', '')
    }
  }
}
</script>
